import configureStore from 'domain/configureStore';

const store = configureStore();

export default store;
